import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
import { RoleEnum } from '../../constants/role.constant';
import { LoginApiModel, TokenModel } from '../../models/auth.model';

@Injectable({
    providedIn: 'root',
})
export class LocalStorageService {
    private readonly USER_KEY = 'p2p_user';
    private currentLoginUser: LoginApiModel | null = null;

    clear(): void {
        localStorage.clear();
    }

    getItem(key: string): string | null {
        return localStorage.getItem(key);
    }

    key(index: number): string | null {
        return null;
    }

    removeItem(key: string): void {
        localStorage.removeItem(key);
    }

    setItem(key: string, value: string): void {
        localStorage.setItem(key, value);
    }

    setLoginUser(loginProfile: LoginApiModel): void {
        this.currentLoginUser = null;
        const stringBaseUser = JSON.stringify(loginProfile);
        const encryptUser = btoa(stringBaseUser);
        this.setItem(this.USER_KEY, encryptUser);
    }

    getLoginUser(): LoginApiModel | null {
        if (this.currentLoginUser !== null) {
            return this.currentLoginUser;
        }

        const encryptUser = this.getItem(this.USER_KEY);
        let user = null;
        try {
            if (encryptUser !== null) {
                const stringBaseUser = atob(encryptUser);
                user = JSON.parse(stringBaseUser);
            }
        } catch {}

        if (!user) {
            return null;
        }

        this.currentLoginUser = user;
        return this.currentLoginUser;
    }

    clearLoginUser(): void {
        this.removeItem(this.USER_KEY);
        this.currentLoginUser = null;
    }

    updateToken(accessToken: string, refreshToken: string): void {
        const user = this.getLoginUser();
        if (!user) {
            return;
        }

        user.accessToken = accessToken;
        user.refreshToken = refreshToken;

        this.setLoginUser(user);
    }

    getUserCurrentRole(): RoleEnum[] | null {
        const user = this.getLoginUser();
        if (!user) {
            return null;
        }

        const jwtData = jwtDecode<TokenModel>(user.accessToken);

        let permissions = jwtData.roleEnums;

        if (typeof jwtData.roleEnums === 'string') {
            permissions = [jwtData.roleEnums];
        }

        return permissions.map((permission) => +permission);
    }
}
